import '../../bins/parts/bin-path-name';
import '../../common/bn-property';
import { LitEntity, html } from '../../utility/lit-entity';

class WorkOrderBin extends LitEntity {
  render() {
    if (!this.entity) {
      return html``;
    }
    const { location = {} } = this.entity.properties;
    return html`
      <bn-property label="Name">
        <bin-path-name
          .href="${this.href}"
          ancestorMinIndex="0"
          stop-at-type="binsentry"
        ></bin-path-name>
      </bn-property>
      <bn-property label="Address">${location.address}</bn-property>
    `;
  }
}

window.customElements.define('work-order-bin', WorkOrderBin);
